<template>
  <div class="howto-content">
    <div class="howto-content-header" @click="onClose" v-if="showQuickHelp">
      <div class="content-icon icon-setting_1"/>
      <div class="content-header-title">{{$t(this.selectMenu.title)}}</div>
      <div class="content-close icon-btn_close" @click="onClose"/>
    </div>
    <div class="howto-content-body">
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="item" v-for="item in contentList" :key="item.index" :class="[(item.cssStyle === 'substep') ? 'tb' : '']">
          <div class="substep-title" v-if="item.stepCount">{{item.stepCount}}</div>
          <div :class="[item.cssStyle]" v-html ="$xss($t(item.title), xssOption)" >{{$t(item.title)}}</div>
        </div>
      </scrollbar>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import config from '../config'
import folder from '../assets/svg/folder.svg'
export default {
  name: 'how-to',
  components: {
    folder
  },
  data () {
    return {
      xssOption: {
        whiteList: {
          span: ['class']
        }
      }
    }
  },
  methods: {
    onClose () {
      this.$store.commit('updateQuickHelp', false)
    }
  },
  computed: {
    ...mapState({
      showQuickHelp: state => state.app.showQuickHelp,
      selectMenu: state => state.app.selectMenu,
      portNumber: state => state.module.portNum,
      sysBoard: state => state.module.sysBoard,
      isFec: state => state.module.isFec
    }),
    contentList () {
      let result = []
      let itemTitle = ''
      let levelCount = 1
      if (this.showQuickHelp && this.selectMenu.path !== 'dashboard') {
        let helpString = (config.helper[this.selectMenu.path]) ? config.helper[this.selectMenu.path] : []
        // if (this.isFec && this.selectMenu.path === 'portstatus') helpString = config.helper['fecportstatus']
        helpString.forEach(element => {
          if (element.importImage) {
            let importimg = {}
            let btnArray = ['backup', 'browse', 'restore', 'check', 'upload']
            element.importImage.forEach(label => {
              if (btnArray.includes(label)) {
                switch (label) {
                  case 'browse':
                    importimg[label] = '<div class="q-button" :title="' + this.$t('updatefw.browse') + '"><folder class="q-icon"/><div class="title">' + this.$t('updatefw.browse') + '</div></div>'
                    break
                  case 'backup':
                    importimg[label] = '<div class="q-button" :title="' + this.$t('systemBackup.backupBtn') + '"><div class="title">' + this.$t('systemBackup.backupBtn') + '</div></div>'
                    break
                  case 'restore':
                    importimg[label] = '<div class="q-button" :title="' + this.$t('systemBackup.restoreBtn') + '"><div class="title">' + this.$t('systemBackup.restoreBtn') + '</div></div>'
                    break
                  case 'upload':
                    importimg[label] = '<div class="q-button" :title="' + this.$t('updatefw.updatesystem') + '"><div class="title">' + this.$t('updatefw.updatesystem') + '</div></div>'
                    break
                  case 'check':
                    importimg[label] = '<div class="q-button" :title="' + this.$t('updatefw.checkupdate') + '"><div class="title">' + this.$t('updatefw.checkupdate') + '</div></div>'
                    break
                }
              } else {
                importimg[label] = '<span class="icon-' + label + '"></span>'
              }
            })
            itemTitle = this.$t(element.title, importimg)
          } else {
            itemTitle = element.title
            if (element.title === 'helper.lagSettingContent2') itemTitle = this.$t(element.title, parseInt(this.portNumber / 2))
          }
          if (element.level === 1) {
            result.push({
              title: this.$t('helper.step', levelCount),
              cssStyle: 'step'
            })
            levelCount++
          } else if (element.level === 2 && element.number) {
            element.cssStyle = 'substep'
          }
          result.push({
            title: itemTitle,
            cssStyle: (element.cssStyle) ? element.cssStyle : '',
            stepCount: (element.level === 2) ? element.number : null
          })
        })
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.howto-content {
  position: relative;
  overflow: hidden;
  color: #000;
  height: 100%;
  >.howto-content-header {
    cursor: pointer;
    height: 40px;
    border-bottom: solid 1px #D8D8D8;
    color: #000;
    display: flex;
    margin: 0px 20px;
    >.content-icon {
      width: 20px;
      height: 20px;
      color: #000;
      margin: auto;
    }
    >.content-header-title {
      flex: 1;
      margin: auto auto auto 10px;
      line-height: 40px;
    }
    >.content-close {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
      cursor: pointer;
      color: #000;
      &:hover {
        color: #89A5F4;
      }
    }
  }
  .scrollbar-body {
    height: 100%;
  }
  .howto-content-body{
    padding: 10px 0px;
    height: calc(100% - 40px);
    font-size: 13px;
    .item {
      padding: 0px 20px;
      color: #2F2F2F;
      /deep/ [class^="icon-"], /deep/ [class*=" icon-"] {
        cursor: default;
        &:hover {
          color: inherit;
        }
      }
      /deep/ .q-button {
        cursor: default;
        &:hover {
          border: 1px solid #000000;
          color: inherit;
        }
      }
      &.tb {
        display: table;
        >.substep-title {
          display: inline-table;
        }
        >.substep {
          display: table-cell;
        }
      }
      .remark {
        color: #195A87;
        text-align: left;
        line-height: 16px;
        padding-top: 20px;
      }
      .step {
        font-family: 'Roboto-B' !important;
        padding-top: 10px;
        color: #2F2F2F;
        line-height: 22px;
      }
      .substep-title {
        display: inline-block;
        background: #EAEAEE;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        text-align: center;
        margin-right: 10px;
      }
      .substep {
        padding-top: 10px;
      }
      .dialog {
        padding-top: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HowTo.vue